    <aside class="page-cta reveal"{{{ root }}}>
      <h2{{{ title.attrs }}}>{{{ title.html }}}</h2>
      <p{{{ text.attrs }}}>{{{ text.html }}}</p>
{{{ buttons }}}
    </aside>
